// extracted by mini-css-extract-plugin
export default {"about_hero_section":"Hero_about_hero_section__dFmaE"};